import { useEffect, useState } from "react"
import DataTable, { TableData, TableHeader } from "../../../components/Table/DataTable"
import ColumnsButton from "../../../components/Buttons/ColumnsButton";
import ListGridToggle from "../../../components/Buttons/ListGridToggle";
import DataGrid from "../../../components/Grid/DataGrid";
import ModelComparisonV2 from "../../Models/components/ModelComparisonV2";
import { formatResultsetValidationsData } from "../../../utils/dataFormattingFns";
import { ResultsetEvaluationMetadata } from "../pages/IndividualResultset";

export default function ModelValidations({
    evalMetadata,
    isLoading,
    setPopupMessage,
}: {
    evalMetadata: ResultsetEvaluationMetadata[],
    isLoading: boolean,
    setPopupMessage: (msg: string, isSuccess: boolean) => void,
}) {
    const [ headers, setHeaders ] = useState<TableHeader[]>([]);
    const [ isGrid, setIsGrid ] = useState(false);
    const [ evalData, setEvalData ] = useState<TableData[]>([]);

    useEffect(() => {
        if (evalMetadata.length > 0) {
            const { evalHeaders, evalData: data  } = formatResultsetValidationsData(evalMetadata);
            setHeaders(evalHeaders);
            setEvalData(data);
        }
    }, [evalMetadata]);

    return (
        <>

        <ModelComparisonV2 
            data={evalData}
            isLoading={isLoading}
        />

        <div style={{maxHeight: 'calc(100vh - 70px)'}} className="mt-10 h-full overflow-hidden flex flex-col justify-start items-stretch gap-4">
                    
            <div className="w-full flex justify-end items-center gap-4">
                <div className="flex justify-end items-center gap-4">
                    {headers && (
                        <ColumnsButton 
                            headers={headers} 
                            setHeaders={setHeaders} 
                            isDisabled={false}
                        />
                    )}
                    <ListGridToggle setIsGrid={setIsGrid} isGrid={isGrid}/>
                </div>
            </div>

            <>
                {isGrid ? (
                    <>
                        <DataGrid 
                            isLoading={isLoading} 
                            gridData={evalData}
                            headers={headers}
                            statsType="model"
                            setPopupMessage={setPopupMessage}
                        />
                    </>
                ) : (
                    <>
                        <DataTable 
                            isLoading={isLoading} 
                            headers={headers} 
                            tableData={evalData}
                            statsType="model"
                            setPopupMessage={setPopupMessage}
                        />                  
                    </>
                )}

            </>
        </div>
        
        </>
    )
}